import { render, staticRenderFns } from "./CiFooter.vue?vue&type=template&id=6f9ae0c5&scoped=true&"
import script from "./CiFooter.vue?vue&type=script&lang=js&"
export * from "./CiFooter.vue?vue&type=script&lang=js&"
import style0 from "./CiFooter.vue?vue&type=style&index=0&id=6f9ae0c5&lang=scss&scoped=true&"
import style1 from "./CiFooter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ae0c5",
  null
  
)

component.options.__file = "CiFooter.vue"
export default component.exports